module.exports = __webpack_public_path__ + "static/media/jawnjawn.8895d51a.png";